import { createRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { rootRoute } from '@/routes/root'
import { ensureAuthenticatedUser } from '@/utils/auth-wall'
import { DateFilterEnum } from '@/utils/dateFilters'

import { NotificationStatusEnum, NotificationTypeEnum } from './domain/notification'
import { Notification } from './notification'
import { NotificationSettings } from './notification-settings'
import { Notifications } from './notifications'
import { NotificationSelect } from './NotificationSelect'

export const notificationCenterSearchSchema = z.object({
  duration: DateFilterEnum.nullish().transform((data) => data ?? undefined),
  durationFrom: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  durationTo: z
    .string()
    .nullish()
    .transform((data) => data ?? undefined),
  status: z
    .array(NotificationStatusEnum)
    .nullish()
    .transform((data) => data ?? undefined),
  type: z.preprocess(
    (value) => {
      // Since daily digest notification links create links like /notifications?type=update, this transforms them to /notifications?type=%5B%22update%22%5D
      if (typeof value === 'string') {
        return [value]
      }
      return value
    },
    z
      .array(NotificationTypeEnum)
      .nullish()
      .transform((data) => data ?? undefined)
  ),
})

export type NotificationCenterSearchType = z.infer<typeof notificationCenterSearchSchema>

export const notificationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/notification-center',
  validateSearch: notificationCenterSearchSchema,
  component: Notifications,
  beforeLoad: ensureAuthenticatedUser,
})

export const notificationSelectRoute = createRoute({
  getParentRoute: () => notificationsRoute,
  path: '/',
  validateSearch: notificationCenterSearchSchema,
  component: NotificationSelect,
  beforeLoad: ensureAuthenticatedUser,
})

export const notificationRoute = createRoute({
  getParentRoute: () => notificationsRoute,
  path: '/$id',
  validateSearch: notificationCenterSearchSchema,
  component: Notification,
  beforeLoad: ensureAuthenticatedUser,
})

export const notificationSettingsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/notification-center/settings',
  beforeLoad: ensureAuthenticatedUser,
  component: NotificationSettings,
})
